@if (titrePage) {
<h1>{{ titrePage }}</h1>
}

<div class="W">
    <sfcu-message [type]="type">
        <p>
            <b>
                {{ title }}
            </b>
        </p>

        @if (description) {
            <p style="white-space: pre-line;">{{ description }}</p>
        }
    </sfcu-message>
</div>

<div class="actions c">
    <sfc-btn-retour [class]="'btn4'" text="Retour à l'accueil"></sfc-btn-retour>
</div>

